import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Spinner = () => (
  <div className="spinnerLoader">
    
    <CircularProgress /><div>Loading</div>
    {/* <CircularProgress size={60} thickness={7} />
    <CircularProgress size={80} thickness={5} /> */}
  </div>
);

export default Spinner;